<template>
  <!-- Sprint 6 follow-up — list of entity emails that aren't linked to a
       Mailjet contact yet. Shown below the cards in NcrmMailjetActivityPanel
       so the operator can add each missing email one-click. Extracted into
       its own component to keep the parent under the size policy. -->
  <div v-if="emails.length" class="ncrm-mailjet-activity__unlinked mt-3">
    <div class="ncrm-mailjet-activity__section-label">
      {{ $t("ncrm.integrations.mailjet.activity.unlinkedEmails.title") }}
    </div>
    <div class="ncrm-mailjet-activity__unlinked-list">
      <div
        v-for="email in emails"
        :key="email"
        class="ncrm-mailjet-activity__unlinked-row"
      >
        <v-icon size="16" color="grey-darken-1">mdi-email-outline</v-icon>
        <span class="ncrm-mailjet-activity__unlinked-email">{{ email }}</span>
        <v-spacer />
        <v-btn
          size="small"
          variant="tonal"
          color="primary"
          @click="$emit('add', email)"
        >
          <v-icon start size="16">mdi-account-plus-outline</v-icon>
          {{ $t("ncrm.integrations.mailjet.activity.unlinkedEmails.addBtn") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NcrmMailjetUnlinkedEmailsList",
  props: {
    emails: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["add"],
};
</script>

<style scoped>
.ncrm-mailjet-activity__section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--app-text-muted, rgba(0, 0, 0, 0.55));
  margin-bottom: 8px;
}
.ncrm-mailjet-activity__unlinked-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ncrm-mailjet-activity__unlinked-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px dashed var(--app-border, rgba(0, 0, 0, 0.15));
  border-radius: 6px;
  background: var(--app-surface-2, rgba(0, 0, 0, 0.02));
}
.ncrm-mailjet-activity__unlinked-email {
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
